import { Workflow } from 'src/redux/consts'
import { SliceStatus } from 'src/redux/types'

import { ActionReducerMapBuilder, Draft } from '@reduxjs/toolkit'

import { setError } from './reducers'
import { UbemIOError } from './types'

type ExtraReducerConfig<T> = {
  workflow: keyof typeof Workflow
  handler?: (
    state: Draft<T>,
    arg: { payload: { error: UbemIOError | null | unknown; key: string } },
  ) => void
}
interface AddErrorExtraReducers {
  <T extends SliceStatus>(builder: ActionReducerMapBuilder<T>, config: ExtraReducerConfig<T>): void
}
export const addErrorExtraReducers: AddErrorExtraReducers = <T extends SliceStatus>(
  builder: ActionReducerMapBuilder<T>,
  { workflow, handler }: ExtraReducerConfig<T>,
) => {
  builder.addCase(setError, (state, { payload }) => {
    if (payload.workflow === workflow) {
      const error = payload.error as UbemIOError | null
      state.error = error
      state.errors[payload.key] = error
      state.isProcessing = false
      if (handler) handler(state, { payload })
    }
  })
}
